/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';

import { SVGIcon } from '@ba/ba-ui-carbon-toolkit';
import upload32 from '@ba/ba-graphics/dist/icons-js/upload_32';
import Empty from 'components/empty/Empty';
import StringResources from 'nls/StringResources';

class EmptyExploreContainer extends Component {
	render() {
		return (
			<div className={'explore-empty-container-dnd'}>
				<Empty
					icon={<SVGIcon iconId={upload32.id} width={32} height={32}/>}
					title={StringResources.get('dnd_create_cards')}
				/>
			</div>
		);
	}
}

export default EmptyExploreContainer;



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/EmptyExploreContainer.js